import { getBaseURL } from 'service/env'

import constants from 'constants/index'

const { REACHABILITY } = constants.externalServices

// Default de quem aplica: entrada do catálogo sem probeTimeoutMs ainda precisa
// de um limite, senão a verificação fica pendurada como a requisição que ela
// deveria diagnosticar.
const DEFAULT_PROBE_TIMEOUT_MS = 5000

// A URL sai do env.js pelo projectTag: o catálogo da API não traz endereço.
const baseUrlFor = (service) =>
  service?.projectTag ? getBaseURL(service.projectTag) : null

const hostFor = (service) => {
  const baseUrl = baseUrlFor(service)

  if (!baseUrl) return null

  try {
    return new URL(baseUrl).host
  } catch {
    return baseUrl
  }
}

// Mede se ESTE navegador alcança o host - nunca se o serviço está no ar.
//
// Fora do axios de propósito: as instâncias injetam headers customizados, que
// forçam um preflight OPTIONS - bloqueado por alguns proxies por conta própria,
// o que confundiria o diagnóstico. Sem headers isto é uma simple request. De
// quebra, escapa dos interceptors que em 4xx/5xx fazem history.push.
const probe = async (service) => {
  const baseUrl = baseUrlFor(service)

  if (!baseUrl || !service?.probePath) return REACHABILITY.UNVERIFIABLE

  const controller = new AbortController()
  const timer = setTimeout(
    () => controller.abort(),
    service.probeTimeoutMs || DEFAULT_PROBE_TIMEOUT_MS,
  )

  try {
    // Cache-buster: proxy corporativo pode servir um 200 cacheado e mascarar
    // o bloqueio.
    const response = await fetch(
      `${baseUrl}${service.probePath}?_=${Date.now()}`,
      {
        method: 'GET',
        cache: 'no-store',
        signal: controller.signal,
      },
    )

    return response.ok ? REACHABILITY.REACHABLE : REACHABILITY.UNREACHABLE
  } catch {
    return REACHABILITY.UNREACHABLE
  } finally {
    clearTimeout(timer)
  }
}

export default {
  probe,
  hostFor,
}
